import renderWidget from './components/renderWidget';

import CheckoutWidget from './components/CheckoutWidget';

export const renderCheckoutWidget = renderWidget(CheckoutWidget);
